'use strict';

const roleSchema = {
  5: {
    Werewolf: 1,
    Villager: 4,
    Cupido: 0,
    Hunter: 0,
    Idiot: 0,
    Guardian: 0,
    Seer: 0,
    Witch: 0
  },
  6: {
    Werewolf: 1,
    Villager: 4,
    Cupido: 0,
    Hunter: 0,
    Idiot: 0,
    Guardian: 0,
    Seer: 0,
    Witch: 1
  },
  7: {
    Werewolf: 2,
    Villager: 3,
    Cupido: 0,
    Hunter: 0,
    Idiot: 0,
    Guardian: 0,
    Seer: 1,
    Witch: 1
  },
  8: {
    Werewolf: 2,
    Villager: 3,
    Cupido: 0,
    Hunter: 0,
    Idiot: 0,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  9: {
    Werewolf: 3,
    Villager: 3,
    Cupido: 0,
    Hunter: 0,
    Idiot: 0,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  10: {
    Werewolf: 3,
    Villager: 3,
    Cupido: 0,
    Hunter: 0,
    Idiot: 1,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  11: {
    Werewolf: 3,
    Villager: 4,
    Cupido: 0,
    Hunter: 0,
    Idiot: 1,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  12: {
    Werewolf: 3,
    Villager: 4,
    Cupido: 0,
    Hunter: 1,
    Idiot: 1,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  13: {
    Werewolf: 3,
    Villager: 4,
    Cupido: 1,
    Hunter: 1,
    Idiot: 1,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  14: {
    Werewolf: 3,
    Villager: 5,
    Cupido: 1,
    Hunter: 1,
    Idiot: 1,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  15: {
    Werewolf: 4,
    Villager: 4,
    Cupido: 1,
    Hunter: 1,
    Idiot: 1,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  16: {
    Werewolf: 4,
    Villager: 5,
    Cupido: 1,
    Hunter: 1,
    Idiot: 1,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  17: {
    Werewolf: 4,
    Villager: 6,
    Cupido: 1,
    Hunter: 1,
    Idiot: 1,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  },
  default: {
    Werewolf: 4,
    Villager: 7,
    Cupido: 1,
    Hunter: 1,
    Idiot: 1,
    Guardian: 1,
    Seer: 1,
    Witch: 1
  }
};

export default roleSchema;



/** WEBPACK FOOTER **
 ** ./scripts/models/roles/roleSchemas.jsx
 **/